{
  "Added by you": "Added by you",
  "Total": "Total",
  "first-challenge": "Your first challenge",
  "second-challenge": "Your second challenge",
  "third-challenge": "Your third challenge",
  "fourth-challenge": "Your fourth challenge",
  "fifth-challenge": "Your fifth challenge",
  "Contact support": "Contact support",
  "Send feedback": "Send feedback",
  "track-time": "Add learning time",
  "External time": "External learning time",
  "Register time spent on external activites": "Log time spent on external learning activities",
  "Time spent on external courses": "Time spent on external courses",
  "Profile": "Profile",
  "Add time": "Add time",
  "current-challenge": "Current challenge",
  "my-learning-goal": "My learning goal",
  "my-learning-progress": "Learning progress",
  "past-six-months": "Past 6 months",
  "my-invested-time": "My learning time",
  "view-completed": "View completed learning",
  "current-year-challenge": "{{startDay}} {{startMonth}} {{startYear}} - {{endDay}} {{endMonth}} {{endYear}}",
  "home-text-top": "The average learning time is {{companyHours}}h. With <0>{{userTime}}</0>, you are in the top {{percentageTop}}%. Impressive, keep it up!",
  "home-text-mid": "The average learning time is {{companyHours}}h. With <0>{{userTime}}</0>, you are in the top {{percentageTop}}%. What is your next move?",
  "home-text-low": "The average learning time is {{companyHours}}h. Your learning time so far is <0>{{userTime}}</0>. What is your next move?",

  "my-invested-time-description": "My learning time is based on progress and completion of all learning types from all partners, including added learning time.",
  "my-invested-time-disclaimer": "Time updates can be delayed up to 72 hours due to technical dependencies.",
  "Manually added other learning time": "Added learning time",
  "What data is not included?": "What data is not included?",
  "continue-Learning": "Continue learning",
  "assigned": "Assigned",
  "my-events": "My Events",
  "saved": "Saved",
  "featured": "Featured",
  "show-all": "Show All",
  "explore-all": "Explore All Learning Items",
  "choose-learnings-items-count": "Choose learnings items ({{count}} available)",
  "featured-learning-items": "Featured learning items",
  "no-featured-learning-items": "No learnings items featured",
  "featured-learnings": "Featured"
}
